module.exports = "<span class=\"badge\" [class.alert]=\"alert\" *ngIf=\"count\">{{count}}</span>\n"